<div *ngIf="isVisible" class="remodal-overlay remodal-is-opened" style="display: block"></div>
<div *ngIf="isVisible" class="remodal-wrapper remodal-is-opened js-modal-back" style="display: block">
  <div
    class="c-modal remodal remodal-is-initialized remodal-is-opened small"
    tabindex="-1"
    style="display: inline-block; padding: 0; margin: 0"
  >
    <div class="c-notice-popup-header">
      <h3>
        <img *ngIf="iconSrc(); else textIcon" [src]="iconSrc()" class="popup-header-icon" />
        <ng-template #textIcon>📢</ng-template>
        {{ notice?.popup?.title }}
      </h3>
      <button class="c-notice-popup-close" (click)="onClose()">×</button>
    </div>

    <div class="c-notice-popup-content">
      <p>{{ notice?.popup?.content }}</p>
      <ul *ngIf="notice?.popup?.listItems && notice?.popup?.listItems.length > 0">
        <li *ngFor="let item of notice?.popup?.listItems">{{ item }}</li>
      </ul>
      <p *ngIf="notice?.popup?.linkText && notice?.linkUrl">
        詳細につきましては、<a [href]="notice?.linkUrl" target="_blank">{{ notice?.popup?.linkText }}</a
        >をご覧ください。
      </p>
    </div>

    <div class="c-notice-popup-footer">
      <div *ngIf="showDontShowAgainKey" class="c-notice-popup-checkbox">
        <label class="checkbox-container">
          <input type="checkbox" [(ngModel)]="dontShowAgainInput" class="checkbox-input" />
          <span class="checkbox-checkmark"></span>
          今後表示しない
        </label>
      </div>
    </div>
    <div class="c-btns">
      <div class="c-btns__item">
        <a class="c-btn" (click)="onClose()" style="cursor: pointer">
          <span>{{ notice?.popup?.closeButtonText || '閉じる' }}</span></a
        >
      </div>
    </div>
  </div>
</div>

<!-- ActionTransaction用の非表示ボタン -->
<button #actionTransactionBtn style="display: none" ActionTransaction [commandCd]="actionTransactionCommandCd"></button>
